import React, { useState, useEffect } from "react";
import { Bookmark } from "lucide-react";
import { useAuth } from "../AuthContext";
import { API_URL } from "../config";

export default function BookmarkButton({ contentType, contentId, onLoginRequest }) {
  const { isLoggedIn, token } = useAuth();
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) { setSaved(false); return; }
    fetch(`${API_URL}/bookmarks/status?content_type=${contentType}&content_id=${contentId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : { saved: false })
      .then(d => setSaved(d.saved))
      .catch(() => {});
  }, [contentType, contentId, token, isLoggedIn]);

  const toggle = async () => {
    if (!isLoggedIn) { onLoginRequest && onLoginRequest(); return; }
    setBusy(true);
    try {
      const r = await fetch(`${API_URL}/bookmarks/toggle`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ content_type: contentType, content_id: contentId }),
      });
      if (r.ok) {
        const d = await r.json();
        setSaved(d.saved);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle} disabled={busy}
      title={saved ? "Убрать из сохранённого" : "Сохранить на потом"}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        background: saved ? "#ffe0ec" : "#f0f2f8", color: saved ? "#e5005b" : "#555",
        border: "none", borderRadius: 8, padding: "6px 14px", fontSize: "0.9rem",
        fontWeight: 600, cursor: "pointer",
      }}
    >
      <Bookmark size={15} strokeWidth={2.2} fill={saved ? "#e5005b" : "none"} />
      {saved ? "Сохранено" : "Сохранить"}
    </button>
  );
}
